import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    FiscalYearClose,
    YearEndClosePreview,
    YearEndCloseResult,
    YearEndCloseSettings,
} from '../interfaces/yearEndClose.interface';

export const YearEndCloseService = {
    list: async (): Promise<FiscalYearClose[]> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(ENDPOINTS.YEAR_END_CLOSE.LIST(institutionId!));
        return res.data;
    },
    preview: async (fiscalYearStart: string): Promise<YearEndClosePreview> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(ENDPOINTS.YEAR_END_CLOSE.PREVIEW(institutionId!), { params: { fiscalYearStart } });
        return res.data;
    },
    close: async (fiscalYearStart: string): Promise<YearEndCloseResult> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.post(ENDPOINTS.YEAR_END_CLOSE.CLOSE(institutionId!), { fiscalYearStart });
        return res.data;
    },
    reopen: async (closeId: string, reason?: string): Promise<YearEndCloseResult> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.post(ENDPOINTS.YEAR_END_CLOSE.REOPEN(institutionId!), { closeId, reason: reason || null });
        return res.data;
    },
    getSettings: async (): Promise<YearEndCloseSettings> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(ENDPOINTS.YEAR_END_CLOSE.SETTINGS(institutionId!));
        return res.data;
    },
    updateSettings: async (retainedEarningsAccountId: string | null): Promise<YearEndCloseSettings> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.put(ENDPOINTS.YEAR_END_CLOSE.SETTINGS_UPDATE, { institutionId, retainedEarningsAccountId });
        return res.data;
    },
};
